import { Anchor, Container, Group, Text } from '@mantine/core'
import type React from 'react'

import classes from './Footer.module.css'

type Link = {
  href: string
  label: string
}

export const Footer = () => {
  const links: Link[] = [
    {
      label: 'About us',
      href: 'https://nextgen.group/ospace',
    },
    {
      label: 'Contact us',
      href: 'https://nextgen.group/contact-us',
    },
  ]
  // const { classes } = useStyles()
  const items = links.map((link) => (
    <Anchor<'a'>
      c='gray'
      key={link.label}
      href={link.href}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => event.preventDefault()}
    >
      {link.label}
    </Anchor>
  ))

  return (
    <div className={classes.footer}>
      <Container className={classes.inner} fluid={true}>
        <Group>
          <Text c='dimmed'>{new Date().getFullYear()} &copy;</Text>
          <Anchor<'a'> c='dark' href='https://nextgen.group/ospace'>
            oSpace
          </Anchor>
        </Group>
        <Group className={classes.links}>{items}</Group>
      </Container>
    </div>
  )
}
